import { useEffect } from 'react';

interface BodyScrollSnapshot {
  body: HTMLElement;
  scrollY: number;
  styles: {
    position: string;
    top: string;
    left: string;
    right: string;
    width: string;
    overflow: string;
  };
}

const activeLocks = new Set<symbol>();
let bodyScrollSnapshot: BodyScrollSnapshot | null = null;

const acquireBodyScrollLock = () => {
  const lockId = Symbol('body-scroll-lock');
  activeLocks.add(lockId);

  if (activeLocks.size === 1) {
    const { body } = document;
    const scrollY = window.scrollY;

    bodyScrollSnapshot = {
      body,
      scrollY,
      styles: {
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        overflow: body.style.overflow,
      },
    };

    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';
    body.style.overflow = 'hidden';
  }

  return () => {
    const wasActive = activeLocks.delete(lockId);

    if (!wasActive || activeLocks.size > 0 || !bodyScrollSnapshot) {
      return;
    }

    const { body, scrollY, styles } = bodyScrollSnapshot;
    body.style.position = styles.position;
    body.style.top = styles.top;
    body.style.left = styles.left;
    body.style.right = styles.right;
    body.style.width = styles.width;
    body.style.overflow = styles.overflow;
    bodyScrollSnapshot = null;
    window.scrollTo(0, scrollY);
  };
};

/**
 * Blokuje przewijanie treści w tle (np. gdy otwarte jest menu mobilne lub modal).
 *
 * Samo `overflow: hidden` na `body` nie blokuje przewijania dotykowego na mobile
 * (szczególnie iOS Safari). Dlatego stosujemy `position: fixed` z zapamiętaniem
 * i odtworzeniem pozycji scrolla po odblokowaniu.
 */
export const useBodyScrollLock = (locked: boolean) => {
  useEffect(() => {
    if (!locked) return;

    return acquireBodyScrollLock();
  }, [locked]);
};
